// @ts-nocheck
/* eslint-disable */
/* NOTE: Auto-generated. Run `yarn build-icons` instead of editing. */
import { ReactComponent as CheckCircleBrokenDefault } from '../../../assets/icons/default/general/check-circle-broken.svg?react';
import { ReactComponent as CheckCircleBrokenSolid } from '../../../assets/icons/solid/general/CHECK-CIRCLE-BROKEN.svg?react';
import { createIcons } from '../../Icon';
const CheckCircleBrokenIcon = /* @__PURE__ */ createIcons('CheckCircleBroken', {
    default: CheckCircleBrokenDefault,
    solid: CheckCircleBrokenSolid
});
CheckCircleBrokenIcon.supportedTypes = ['default', 'solid'];
CheckCircleBrokenIcon.category = 'general';
export default CheckCircleBrokenIcon;
